import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { InlineBannerComponent } from '../../../shared/components/inline-banner/inline-banner.component';

@Component({
    selector: 'vision2-section-4',
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        InlineBannerComponent,
    ],
    templateUrl: './section-4.component.html',
    styleUrl: './section-4.component.scss',
})
export class Section4Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    constructor(private helpers: PartialsHelpersService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-4': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-4',
                BASE_SUFFIXES,
                [],
            ),
            'SECTION-4_INLINE-BANNER': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-4_INLINE-BANNER',
                BASE_SUFFIXES,
                [0, 1],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }
}
